<template>
  <div
    ref="content"
    class="w-full transition-all duration-500 px-4"
    :class="changeBackgroundColor ? 'bg-[#F44F1A]' : 'bg-[#FFF]'"
  >
    <div class="mx-auto px-4 md:px-7 lg:px-0 lg:max-w-[1064px] overflow-hidden">
      <div
        class="h-[500px] lg:h-screen mt-[60px] lg:mt-0 w-full flex justify-center items-center flex-col"
      >
        <p
          :style="{ color: textColor }"
          class="poppins uppercase font-semibold text-[31.25px] lg:text-[76.29px] leading-[100%] text-center max-w-[315px] lg:max-w-[770px] w-full"
        >
          "Do not know, then do not love!"
        </p>
        <svg
          :class="
            changeBackgroundColor ? 'reverse-rotation' : 'decoration-rotation'
          "
          class="w-[88px] h-[88px] lg:w-[159px] lg:h-[159px] mt-8"
          viewBox="0 0 162 162"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M66.3107 161.745L72.6232 139.964H75.8107L80.8732 157.495L86.1232 139.964L89.2794 139.933L95.3732 161.745H92.3419L87.5919 143.276L82.3419 161.745H79.1544L74.1544 143.339L69.3732 161.745H66.3107Z"
            :fill="textColor"
          />
          <path
            d="M27.791 138.252L32.9396 133.104L27.3269 127.491L28.9842 125.834L34.5969 131.446L39.9002 126.143L33.6246 119.868L35.2819 118.21L43.5683 126.497L28.1445 141.92L19.8581 133.634L21.5154 131.977L27.791 138.252Z"
            :fill="textColor"
          />
          <path
            d="M20.4543 82.9581L20.4543 75.3331H22.7668L22.7668 85.8019H0.985595L0.985595 82.9581H20.4543Z"
            :fill="textColor"
          />
          <path
            d="M24.9007 39.6747C23.3981 38.1721 22.389 36.4853 21.8734 34.6144C21.3431 32.7288 21.321 30.8653 21.8071 29.0239C22.308 27.1677 23.2729 25.5252 24.7019 24.0962C26.3812 22.4168 28.2521 21.3562 30.3145 20.9142C32.3769 20.4723 34.4393 20.708 36.5017 21.6213L34.0931 24.0299C32.7378 23.529 31.4046 23.4333 30.0935 23.7427C28.7972 24.0373 27.5892 24.7444 26.4696 25.864C25.3942 26.9394 24.6798 28.1547 24.3262 29.51C23.9726 30.8653 24.0168 32.25 24.4588 33.6642C24.886 35.0637 25.7183 36.3822 26.9558 37.6196C28.1785 38.8423 29.4969 39.6747 30.9111 40.1166C32.3106 40.5438 33.688 40.5806 35.0433 40.2271C36.3986 39.8735 37.6139 39.1591 38.6893 38.0837C39.8089 36.9641 40.5234 35.7635 40.8327 34.4818C41.1421 33.1707 41.0463 31.8376 40.5455 30.4823L42.954 28.0737C43.8527 30.1213 44.081 32.1764 43.6391 34.2388C43.1824 36.2864 42.1144 38.15 40.435 39.8293C39.006 41.2583 37.3708 42.2305 35.5294 42.7461C33.688 43.2323 31.8318 43.2176 29.961 42.702C28.0901 42.1864 26.4033 41.1773 24.9007 39.6747Z"
            :fill="textColor"
          />
          <path
            d="M81.6832 23.1825C79.6623 23.1825 77.8186 22.7138 76.1519 21.7763C74.4853 20.8179 73.1623 19.495 72.1832 17.8075C71.2248 16.0992 70.7457 14.1825 70.7457 12.0575C70.7457 9.93251 71.2248 8.02626 72.1832 6.33876C73.1623 4.63043 74.4853 3.30751 76.1519 2.37001C77.8186 1.41168 79.6623 0.932509 81.6832 0.932509C83.7249 0.932509 85.579 1.41168 87.2457 2.37001C88.9124 3.30751 90.2249 4.62001 91.1832 6.30751C92.1415 7.99501 92.6207 9.91168 92.6207 12.0575C92.6207 14.2033 92.1415 16.12 91.1832 17.8075C90.2249 19.495 88.9124 20.8179 87.2457 21.7763C85.579 22.7138 83.7249 23.1825 81.6832 23.1825ZM81.6832 20.7138C83.204 20.7138 84.5686 20.3596 85.7769 19.6513C87.0061 18.9429 87.9644 17.9325 88.6519 16.62C89.3603 15.3075 89.7144 13.7867 89.7144 12.0575C89.7144 10.3075 89.3603 8.78668 88.6519 7.49501C87.9644 6.18251 87.0165 5.17209 85.8082 4.46376C84.5998 3.75543 83.2248 3.40126 81.6832 3.40126C80.1415 3.40126 78.7665 3.75543 77.5582 4.46376C76.3498 5.17209 75.3915 6.18251 74.6832 7.49501C73.9957 8.78668 73.6519 10.3075 73.6519 12.0575C73.6519 13.7867 73.9957 15.3075 74.6832 16.62C75.3915 17.9325 76.3498 18.9429 77.5582 19.6513C78.7873 20.3596 80.1623 20.7138 81.6832 20.7138Z"
            :fill="textColor"
          />
          <path
            d="M146.027 32.9104L130.736 48.2016L128.725 46.1907L140.127 34.7886L123.643 41.1084L122.229 39.6942L128.549 23.1656L117.124 34.5898L115.114 32.5789L130.405 17.2877L132.57 19.4533L125.588 37.7497L143.884 30.767L146.027 32.9104Z"
            :fill="textColor"
          />
          <path
            d="M159.236 79.1213H151.954V87.0588H149.611V79.1213H142.111V87.9963H139.767V76.2776H161.579V87.9963H159.236V79.1213Z"
            :fill="textColor"
          />
          <path
            d="M137.016 139.249L126.211 127.958L127.89 126.278L139.182 137.084L137.016 139.249ZM122.476 122.721C122.859 122.338 123.316 122.146 123.846 122.146C124.377 122.146 124.833 122.338 125.216 122.721C125.599 123.104 125.791 123.56 125.791 124.091C125.791 124.621 125.599 125.078 125.216 125.461C124.848 125.829 124.406 126.006 123.891 125.991C123.36 125.991 122.904 125.8 122.52 125.417C122.137 125.034 121.946 124.577 121.946 124.046C121.931 123.531 122.108 123.089 122.476 122.721Z"
            :fill="textColor"
          />
        </svg>
      </div>
      <div
        class="h-[500px] lg:h-screen w-full flex justify-center items-center"
      >
        <div
          :style="{ color: textColor }"
          class="w-full max-w-screen-lg mx-auto flex flex-col lg:flex-row items-start lg:items-end justify-between relative"
        >
          <p
            class="w-full poppins max-w-[200px] lg:max-w-[360px] capitalize text-[48px] lg:text-[76.29px] leading-[100%] underline decoration-2"
          >
            You are viewing my Portfolio
          </p>
          <div>
            <div
              class="poppins max-w-[513px] text-[16px] lg:text-xl leading-[150%] font-normal text-justify justify-between mt-4"
            >
              <p class="mb-2 underline">Hello and welcome!</p>
              <p>
                I’m thrilled to show you what I’ve been working on. This is more
                than just a portfolio — it’s a part of my story.
              </p>
              <p>So scroll down, click around, and enjoy the ride!</p>
            </div>
            <svg
              :class="
                changeBackgroundColor
                  ? 'decoration-rotation'
                  : 'reverse-rotation'
              "
              class="hidden w-[192px] h-[190px] absolute top-[-50%] right-0"
              width="192"
              height="190"
              viewBox="0 0 192 190"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M109.014 72.2923C136.209 40.7846 162.747 87.3899 122.12 94.9385C162.747 102.816 135.881 149.092 109.014 117.584C122.775 156.969 69.3694 156.641 83.1304 117.584C55.936 149.092 29.3971 102.816 70.0247 94.9385C29.0694 87.3899 55.936 41.1128 83.1304 72.2923C69.0417 33.2359 122.775 33.2359 109.014 72.2923ZM95.9082 89.0309C99.1849 89.0309 102.134 91.6565 102.134 94.9385C102.134 98.2205 99.1849 101.175 95.9082 101.175C92.632 101.175 90.0106 98.2205 90.0106 94.9385C90.0106 91.6565 92.632 89.0309 95.9082 89.0309Z"
                :fill="textColor"
              />
              <path
                d="M87.4451 185.781V164H90.2889V173.875H101.383V164H104.226V185.781H101.383V176.219H90.2889V185.781H87.4451Z"
                :fill="textColor"
              />
              <path
                d="M67.6806 178.907L70.1709 172.065L62.7121 169.35L63.5137 167.147L70.9725 169.862L73.5377 162.814L65.1979 159.779L65.9995 157.577L77.0115 161.585L69.5512 182.082L58.5392 178.074L59.3408 175.871L67.6806 178.907Z"
                :fill="textColor"
              />
              <path
                d="M51.1201 150.589L45.279 145.688L46.7655 143.916L54.785 150.646L40.7843 167.331L38.6058 165.503L51.1201 150.589Z"
                :fill="textColor"
              />
              <path
                d="M34.8029 131.95L30.9904 125.347L32.9931 124.191L38.2275 133.257L19.3644 144.148L17.9425 141.685L34.8029 131.95Z"
                :fill="textColor"
              />
              <path
                d="M27.9914 106.453C28.3423 108.444 28.2009 110.341 27.567 112.145C26.9126 113.953 25.8396 115.485 24.3477 116.742C22.8318 117.983 21.0274 118.788 18.9347 119.157C16.842 119.526 14.8815 119.385 13.0532 118.734C11.2008 118.066 9.66825 116.993 8.45558 115.515C7.22239 114.04 6.43034 112.307 6.07943 110.317C5.7249 108.306 5.87481 106.397 6.52917 104.589C7.16302 102.785 8.22766 101.265 9.72311 100.028C11.2186 98.7912 13.0229 97.9865 15.1361 97.6139C17.2494 97.2413 19.2201 97.3803 21.0484 98.0311C22.8767 98.6818 24.4074 99.7446 25.6406 101.22C26.8533 102.698 27.6369 104.443 27.9914 106.453ZM25.5602 106.882C25.2961 105.384 24.7103 104.102 23.8029 103.035C22.8919 101.948 21.7304 101.179 20.3185 100.73C18.9029 100.26 17.3437 100.176 15.6408 100.476C13.9174 100.78 12.4812 101.393 11.3321 102.315C10.1589 103.22 9.32848 104.329 8.84073 105.642C8.35299 106.954 8.24297 108.37 8.51067 109.888C8.77838 111.407 9.36593 112.699 10.2733 113.766C11.1807 114.833 12.3422 115.601 13.7578 116.071C15.1492 116.524 16.7066 116.598 18.43 116.294C20.1329 115.994 21.571 115.392 22.7441 114.487C23.9137 113.561 24.7424 112.442 25.2301 111.129C25.7142 109.795 25.8242 108.38 25.5602 106.882Z"
                :fill="textColor"
              />
              <path
                d="M6.66211 77.8181L21.99 80.8698L21.5776 83.2088L6.13031 80.834L6.66211 77.8181ZM28.0529 83.0178C27.9589 83.5512 27.6946 83.97 27.2602 84.2742C26.8258 84.5784 26.3418 84.6835 25.8084 84.5894C25.275 84.4953 24.8562 84.2311 24.552 83.7967C24.2478 83.3623 24.1427 82.8783 24.2368 82.3449C24.3272 81.832 24.5878 81.4337 25.0187 81.15C25.4531 80.8458 25.937 80.7408 26.4704 80.8348C27.0039 80.9289 27.4227 81.1931 27.7269 81.6275C28.0347 82.0414 28.1434 82.5049 28.0529 83.0178Z"
                :fill="textColor"
              />
              <path
                d="M47.674 28.7997L49.2208 30.643L39.6691 38.6577L38.1224 36.8144L47.674 28.7997Z"
                :fill="textColor"
              />
              <path
                d="M104.183 4.21875V26H101.339V16.125L90.2457 16.125V26H87.4019V4.21875H90.2457V13.7812L101.339 13.7812V4.21875H104.183Z"
                :fill="textColor"
              />
              <path
                d="M123.948 11.0933L121.457 17.9354L128.916 20.6502L128.115 22.8526L120.656 20.1379L118.091 27.1855L126.43 30.221L125.629 32.4234L114.617 28.4153L122.077 7.91828L133.089 11.9263L132.287 14.1287L123.948 11.0933Z"
                :fill="textColor"
              />
              <path
                d="M140.508 39.4109L146.349 44.3121L144.863 46.0836L136.843 39.3544L150.844 22.669L153.022 24.4969L140.508 39.4109Z"
                :fill="textColor"
              />
              <path
                d="M156.825 58.0496L160.638 64.653L158.635 65.8093L153.401 56.7431L172.264 45.8525L173.686 48.3152L156.825 58.0496Z"
                :fill="textColor"
              />
              <path
                d="M163.637 83.5466C163.286 81.5565 163.427 79.6594 164.061 77.8552C164.716 76.0475 165.789 74.5149 167.281 73.2576C168.797 72.0172 170.601 71.2125 172.694 70.8435C174.786 70.4744 176.747 70.6153 178.575 71.2661C180.428 71.9337 181.96 73.0068 183.173 74.4854C184.406 75.9603 185.198 77.6928 185.549 79.6829C185.903 81.6936 185.754 83.6028 185.099 85.4106C184.465 87.2147 183.401 88.7352 181.905 89.972C180.41 91.2088 178.605 92.0135 176.492 92.3861C174.379 92.7587 172.408 92.6197 170.58 91.9689C168.752 91.3182 167.221 90.2554 165.988 88.7804C164.775 87.3019 163.991 85.5573 163.637 83.5466ZM166.068 83.1179C166.332 84.6157 166.918 85.898 167.825 86.965C168.736 88.0525 169.898 88.8208 171.31 89.2699C172.725 89.7396 174.285 89.8243 175.988 89.524C177.711 89.2201 179.147 88.6073 180.296 87.6854C181.469 86.7804 182.3 85.6715 182.788 84.3585C183.275 83.0455 183.385 81.6299 183.118 80.1116C182.85 78.5934 182.262 77.3008 181.355 76.2338C180.448 75.1668 179.286 74.3985 177.871 73.9289C176.479 73.4761 174.922 73.4017 173.198 73.7055C171.495 74.0058 170.057 74.6084 168.884 75.5134C167.715 76.4389 166.886 77.5581 166.398 78.8711C165.914 80.2046 165.804 81.6202 166.068 83.1179Z"
                :fill="textColor"
              />
              <path
                d="M184.966 112.182L169.638 109.13L170.051 106.791L185.498 109.166L184.966 112.182ZM163.575 106.982C163.669 106.449 163.934 106.03 164.368 105.726C164.803 105.422 165.286 105.317 165.82 105.411C166.353 105.505 166.772 105.769 167.076 106.203C167.381 106.638 167.486 107.122 167.392 107.655C167.301 108.168 167.04 108.566 166.61 108.85C166.175 109.154 165.691 109.259 165.158 109.165C164.624 109.071 164.206 108.807 163.901 108.372C163.594 107.959 163.485 107.495 163.575 106.982Z"
                :fill="textColor"
              />
              <path
                d="M143.954 161.2L142.408 159.357L151.959 151.342L153.506 153.186L143.954 161.2Z"
                :fill="textColor"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const changeBackgroundColor = ref(false);
const textColor = ref("#F44F1A");

const handleScroll = () => {
  // console.log(window.innerHeight);
  if (window.scrollY > 300) {
    changeBackgroundColor.value = true;
    textColor.value = "#FFF";
  } else {
    changeBackgroundColor.value = false;
    textColor.value = "#F44F1A";
  }
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style lang="scss" scoped>
@mixin desktop {
  @media (min-width: 1024px) {
    @content;
  }
}
.decoration-rotation {
  animation: rotation 10s infinite linear;
}
.reverse-rotation {
  animation: reverse 10s infinite linear;
}
@keyframes rotation {
  rom {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}
@keyframes reverse {
  rom {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.hidden {
  display: none;
  @include desktop {
    display: block;
  }
}
</style>
